// @i18n-ignore-file
import { useStatsigClient } from '@statsig/react-bindings'

import QuinceApiError from '@src/quince-site-common/src/domains/quince-api-error'

import { DEFAULT_STATSIG_ECOMM_SSR_DYNAMIC_CONFIG } from './statsig-dynamic-config.constants'

/**
 * Hook to access Statsig dynamic configuration values
 * @param key - The key of the dynamic configuration to access
 * @returns The configuration value or null if not found/error occurs
 */
export const useStatsigDynamicConfig = <T>(key: string): T => {
  const { getDynamicConfig } = useStatsigClient()
  try {
    const statsigDynamicConfig = (getDynamicConfig('ecomm-ssr').get(key) ??
      DEFAULT_STATSIG_ECOMM_SSR_DYNAMIC_CONFIG[key as keyof typeof DEFAULT_STATSIG_ECOMM_SSR_DYNAMIC_CONFIG]) as T
    return statsigDynamicConfig
  } catch (error) {
    // Create and throw the error to be handled by error boundaries
    throw new QuinceApiError({
      apiName: 'Get Statsig Config',
      message: 'Failed while getting statsig config',
      error: error as Error,
    })
  }
}

export const useStatsigDynamicB2BConfig = <T>(key: string): T | undefined => {
  const { getDynamicConfig } = useStatsigClient()

  try {
    const statsigDynamicConfig = getDynamicConfig('b2b-config').get(key)
    return statsigDynamicConfig as T | undefined
  } catch (error) {
    throw new QuinceApiError({
      apiName: 'Get Statsig B2B Config',
      message: 'Failed while getting statsig b2b config',
      error: error as Error,
    })
  }
}
